module.exports = __webpack_public_path__ + "img/q.b45c44d9.jpg";